import type { AsyncBelongsTo } from '@ember-data/model';
import Model, { attr, belongsTo } from '@ember-data/model';
import type Company from 'garaje/models/company';
import type Location from 'garaje/models/location';

export default class LocationsCapacity extends Model {
  @attr('date') declare capacityDate: Date;
  @attr('number') declare capacityLimit: number;
  @attr('number') declare onSiteCount: number;
  @attr('number') declare expectedCount: number;
  @attr('number') declare inCount: number;
  @attr('number') declare outCount: number;
  @belongsTo('location', { async: true, inverse: null }) declare location: AsyncBelongsTo<Location>;
  @belongsTo('company', { async: true, inverse: null }) declare company: AsyncBelongsTo<Company>;

  get capacityUsed(): number {
    return this.onSiteCount + this.expectedCount;
  }

  get capacityRatio(): number {
    return this.capacityLimit >= 0 ? this.capacityUsed / this.capacityLimit : 0;
  }

  get hasCapacity(): boolean {
    return this.capacityRatio < 1;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'locations-capacity': LocationsCapacity;
  }
}
